// Copy-to-clipboard button: idle | copied | failed, self-resetting. The same
// pattern FixCard and IncidentsPanel carry locally — shared for new screens.
import { useState } from 'react';

export default function CopyButton({ text, label = 'Copy', primary = false }) {
  const [state, setState] = useState('idle');
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
    setTimeout(() => setState('idle'), 1600);
  }
  return (
    <button type="button" className={primary ? 'primary-btn' : 'ghost-btn'} onClick={copy} aria-live="polite">
      {state === 'copied' ? 'Copied ✓' : state === 'failed' ? 'Select & copy manually' : label}
    </button>
  );
}
